"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MatchingData = exports.SpokenLanguage = void 0;
const validator_1 = require("@leavy/validator");
const ddd_1 = require("../../../infrastructure/ddd");
const CityKnowledge_1 = require("./CityKnowledge");
const MissionFrequency_1 = require("./MissionFrequency");
const FavoriteTransport_1 = require("./FavoriteTransport");
const Personality_1 = require("./Personality");
const FavoriteFlatType_1 = require("./FavoriteFlatType");
const SpokenLanguageModel_1 = require("./SpokenLanguageModel");
const FavoriteActivity_1 = require("./FavoriteActivity");
const utils_1 = require("@leavy/utils");
class SpokenLanguage extends ddd_1.ValueObjectBase {
    constructor(data) {
        super();
        this.initialize(data);
    }
    isComplete() {
        return (utils_1.Guard.isNotNullish(this.langCode) && utils_1.Guard.String.isNotEmpty(this.langCode)
            && utils_1.Guard.isNotNullish(this.level) && utils_1.Guard.Enum.isEnumMember(SpokenLanguageModel_1.SpokenLanguageLevel)(this.level));
    }
    toPlain() {
        return { ...this };
    }
}
exports.SpokenLanguage = SpokenLanguage;
class MatchingData extends ddd_1.ValueObjectBase {
    constructor(data) {
        super();
        this.initialize(data);
    }
    isComplete() {
        return ((utils_1.Guard.isNotNullish(this.activities)
            && this.activities.length > 0
            && this.activities.every(x => utils_1.Guard.Enum.isEnumMember(FavoriteActivity_1.FavoriteActivity)(x)))
            && (utils_1.Guard.isNotNullish(this.personality)
                && this.personality.length > 0
                && this.personality.every(x => utils_1.Guard.Enum.isEnumMember(Personality_1.Personality)(x)))
            && (utils_1.Guard.isNotNullish(this.transport)
                && this.transport.length > 0
                && this.transport.every(x => utils_1.Guard.Enum.isEnumMember(FavoriteTransport_1.FavoriteTransport)(x)))
            && (utils_1.Guard.isNotNullish(this.cityKnowledge)
                && utils_1.Guard.Enum.isEnumMember(CityKnowledge_1.CityKnowledge)(this.cityKnowledge))
            && (utils_1.Guard.isNotNullish(this.favoriteFlats)
                && this.favoriteFlats.length > 0
                && this.favoriteFlats.every(x => utils_1.Guard.Enum.isEnumMember(FavoriteFlatType_1.FavoriteFlatType)(x)))
            && (utils_1.Guard.isNotNullish(this.frequency)
                && utils_1.Guard.Enum.isEnumMember(MissionFrequency_1.MissionFrequency)(this.frequency))
            && (utils_1.Guard.isNotNullish(this.languages)
                && this.languages.length > 0
                && this.languages.every(x => x.isComplete())));
    }
    toPlain() {
        return { ...this };
    }
}
__decorate([
    (0, validator_1.Type)(() => SpokenLanguage),
    __metadata("design:type", Array)
], MatchingData.prototype, "languages", void 0);
exports.MatchingData = MatchingData;
//# sourceMappingURL=MatchingData.js.map